import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState(
    () => localStorage.getItem('vflow_business') 
      ? JSON.parse(localStorage.getItem('vflow_business')) 
      : null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vflow_token');
    const savedUser = localStorage.getItem('vflow_user');
    if (token && savedUser) {
      api.get('/auth/me')
        .then(() => {
          setUser(JSON.parse(savedUser));
          return api.get('/businesses/my', {
            headers: { Authorization: 'Bearer ' + token }
          });
        })
        .then((bizRes) => {
          const biz = bizRes.data;
          if (biz && biz.id) {
            localStorage.setItem('vflow_business', JSON.stringify(biz));
            setSelectedBusiness(biz);
          } else {
            localStorage.removeItem('vflow_business');
            setSelectedBusiness(null);
          }
        })
        .catch(() => {
          localStorage.removeItem('vflow_token');
          localStorage.removeItem('vflow_user');
          localStorage.removeItem('vflow_business');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('vflow_token', data.token);
    localStorage.setItem('vflow_user', JSON.stringify(data.user));
    // Login aana udane correct business auto-set pannrom
    try {
      const bizRes = await api.get('/businesses/my', {
        headers: { Authorization: 'Bearer ' + data.token }
      });
      const biz = bizRes.data;
      if (biz && biz.id) {
        localStorage.setItem('vflow_business', JSON.stringify(biz));
        setSelectedBusiness(biz);
      } else {
        localStorage.removeItem('vflow_business');
        setSelectedBusiness(null);
      }
    } catch (e) {
      localStorage.removeItem('vflow_business');
      setSelectedBusiness(null);
    }
    setUser(data.user);
    return data;
  };

  const loginWithToken = async (token, userData) => {
    localStorage.setItem('vflow_token', token);
    localStorage.setItem('vflow_user', JSON.stringify(userData));
    try {
      const bizRes = await api.get('/businesses/my', {
        headers: { Authorization: 'Bearer ' + token }
      });
      const biz = bizRes.data;
      if (biz && biz.id) {
        localStorage.setItem('vflow_business', JSON.stringify(biz));
        setSelectedBusiness(biz);
      } else {
        localStorage.removeItem('vflow_business');
        setSelectedBusiness(null);
      }
    } catch (e) {
      localStorage.removeItem('vflow_business');
      setSelectedBusiness(null);
    }
    setUser(userData);
  };
  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  const selectBusiness = (biz) => {
    setSelectedBusiness(biz);
    localStorage.setItem('vflow_business', JSON.stringify(biz));
  };

  return (
    <AuthContext.Provider value={{ user, selectedBusiness, selectBusiness, login, loginWithToken, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
